import $ from 'jquery';

const $body = $('body');
/**
 * Utility for adding keyboard-only focus styles
 * Usage:
 *
  a {
    .is-keyboard &:focus,
    &:hover {
      ...
    }
  }
 */

$(function () {
  $body
    .on('keydown', function () {
      $body.addClass('is-keyboard');
    })
    .on('mousedown', function () {
      $body.removeClass('is-keyboard');
    });
});
